import routes from './index';

/**
 * List of routes that should have dark mode enabled
 */
export const DARK_MODE_ROUTES = [
    routes.bonds.base,
    routes.bonds.bondsIsin,
    routes.bonds.baseIsin,
];

/**
 * List of routes that should have full width layout
 */
export const FULL_WIDTH_ROUTES = [
    '/media',
    routes.bonds.base,
    routes.bonds.bondsIsin,
    '/webinars',
    '/calculators',
];

/**
 * Checks if the current path should have dark mode enabled
 * @param {string} pathname - The current router pathname
 * @returns {boolean} - Returns true if the current page should have dark mode
 */
export const hasDarkMode = (pathname) => {
    return DARK_MODE_ROUTES.some((path) => pathname.includes(path));
};

/**
 * Checks if the current path should have full width layout
 * @param {string} pathname - The current router pathname
 * @returns {boolean} - Returns true if the current page should have full width
 */
export const hasFullWidth = (pathname) => {
    return FULL_WIDTH_ROUTES.some((path) => pathname.includes(path));
};
